export const CREDITS_PURCHASED = 'Credits Purchased';
export const CASH_PAID = 'Cash Paid';
export const TRANSACTIONS = 'Transactions';
export const COUNT_OF_TRANSACTIONS = 'Count of Transactions';
export const VOLUME_OF_TRANSACTIONS = 'Volume of Transactions';
export const CREDIT_REDEEMED = 'Credit Redeemed';
